import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getPettyCashAccounts = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-accounts/`, body);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashAccounts - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashAccountById = async (pettyCashAccount) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-accounts/${pettyCashAccount}`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashAccountById - error", error)
        return handleApiError(error)
    }
}

export const insertPettyCashAccount = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-accounts/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertPettyCashAccount - error", error)
        return handleApiError(error)
    }
}

export const updatePettyCashAccount = async (pettyCashAccountsId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-accounts/update/${pettyCashAccountsId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updatePettyCashAccount - error", error)
        return handleApiError(error)
    }
}

export const updatePettyCashAccountStatusById = async (pettyCashAccountsId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-accounts/status/${pettyCashAccountsId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updatePettyCashAccountStatusById - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashAccountByUserId = async (userId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-accounts/by-userId/${userId}`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashAccountByUserId - error", error)
        return handleApiError(error)
    }
}